import React from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import extractDialogProps from 'components/extractDialogProps';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';

import { useSnackbar } from 'notistack';

import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';

import useClient from 'components/Auth/useClient';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width:'100%'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  dialogContent: {
    width: '100%'
  },
  actions: {
    width: '100%',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function RegisterDialog(props) {
  const [dialogProps] = extractDialogProps(props);
  const classes = useStyles();

  const {
    email,
    handleClose,
  } = props;

  const { enqueueSnackbar } = useSnackbar();

  const client = useClient();
  const handleSend = React.useCallback(() => {
    client.post('api/user/sendRegistrationMail')
      .then(() => {
        handleClose();
        enqueueSnackbar('新規ユーザー登録メールの送信が完了しました。\nメールのリンクから30分以内に新規登録を完了して下さい。', {  style: { whiteSpace: 'pre-line' } });
      })
      .catch(() => {
        enqueueSnackbar('メールが送信できませんでした。', {  variant: 'error' });
      });
  }, [client, email]);


  return (
    <div>
      <Dialog
        {...dialogProps}
        aria-labelledby="register-dialog-title"
        aria-describedby="register-dialog-description"
        fullWidth="true"
        className={classes.dialog}
      >
        <Container className={classes.container}>
        <Avatar className={classes.avatar} />
        <DialogContent dividers="true" className={classes.dialogContent}>
          <Typography>
            ユーザー登録を行うことで、過去に受信したドキュメントの一覧を参照できるようになります。
          </Typography>
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={handleSend}>
              ユーザー登録メールを送信する
            </Button>
          </DialogActions>
        </Container>
      </Dialog>
    </div>
  );
}